import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
var ContactPage = function ContactPage(_ref) {
    var data = _ref.data, location = _ref.location;
    var siteTitle = data.site.siteMetadata.title;
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location,
        title: siteTitle
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: "\u304A\u554F\u3044\u5408\u308F\u305B"
    }), /*#__PURE__*/ React.createElement("form", {
        className: "bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4",
        name: "contact",
        method: "POST",
        "data-netlify": "true",
        "data-netlify-honeypot": "bot-field"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "form-name",
        value: "contact"
    }), /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "bot-field"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "form-group mb-4"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2"
    }, "\u304A\u540D\u524D"), /*#__PURE__*/ React.createElement("input", {
        type: "text",
        className: "form-control shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "name",
        name: "name",
        placeholder: "\u304A\u540D\u524D",
        maxLength: 30,
        minLength: 2,
        required: true,
        autoComplete: "name"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "form-group mb-4"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2"
    }, "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"), /*#__PURE__*/ React.createElement("input", {
        type: "email",
        className: "form-control shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "email",
        name: "email",
        placeholder: "",
        pattern: "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$",
        required: true,
        autoComplete: "email"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "form-group mb-6"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "block text-gray-700 text-sm font-bold mb-2"
    }, "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9"), /*#__PURE__*/ React.createElement("textarea", {
        className: "form-control shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
        id: "contact",
        name: "content",
        rows: 8,
        required: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "submit"
    }, "\u9001\u4FE1"))));
};
export default ContactPage;
export var pageQuery = "3159585216";
